import { NavItem, NumberFormat } from '@billy/design-system'
import sortBy from 'lodash/sortBy'

import { TaxRate, TaxRateGroup } from '@modules-deprecated/app/taxrates/types'

import { LocaleIdentifier } from '../../../../../types/localeIdentifier'

const regionOrder: Record<TaxRateGroup, number> = {
  local: 0,
  eu: 1,
  world: 2,
  null: 3,
}

interface GetVatRateSelectItemsOptions {
  locale: LocaleIdentifier
  taxRates: TaxRate[]
}

// The API name already includes the percentage, the kind, and the category
// (e.g. "0% Goods EU"), so the menu is a flat list of those names.
export const getVatRateSelectItems = ({ locale, taxRates }: GetVatRateSelectItemsOptions): NavItem<TaxRate>[] =>
  sortBy(taxRates, [(taxRate) => regionOrder[taxRate.taxRateGroup], 'priority', 'name']).map((taxRate) => {
    const percent = NumberFormat.getPercentNumber(taxRate.rate, locale)
    // The design-system matcher calls `toLowerCase` on the label, so a missing name falls back to the percent.
    const name = taxRate.name || percent

    return {
      children: name,
      id: taxRate.id,
      searchKeywords: [percent, taxRate.name].filter((keyword): keyword is string => Boolean(keyword)),
      value: taxRate,
    }
  })
